<template>
    <v-dialog
        v-if="isVisible"
        v-model="isVisible"
        transition="dialog-top-transition"
        scrollable
        persistent
        max-width="700"
    >
        <v-card class="modal-maincard">

            <v-toolbar dark flat dense>
                <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
            </v-toolbar>

            <v-card-text
                class="wrapperFormModal"
            >
                <v-card flat>
                    <v-card-text>
                        
                        <v-form ref="form" lazy-validation>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Адрес_организации")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-textarea 
                                        v-model="address"
                                        rows="3"
                                        no-resize
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        :rules="requiredRule"
                                    />
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Телефон_организации")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-textarea 
                                        v-model="phone"
                                        rows="3"
                                        no-resize
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        :rules="requiredRule"
                                    />
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Заключение")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-textarea 
                                        v-model="conclusion"
                                        rows="3"
                                        no-resize
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        :rules="requiredRule"
                                    />
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Рекомендации")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-textarea 
                                        v-model="recommendations"
                                        rows="3"
                                        no-resize
                                        hide-details
                                        required
                                        outlined
                                        dense
                                        :rules="requiredRule"
                                    />
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("Заключение_действительно_до")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <v-menu
                                        v-model="srokMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                :value="reallyBefore | formattedDate"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on" 
                                                hide-details
                                                outlined
                                                dense
                                                class="datepick-input"
                                            >
                                            </v-text-field>
                                        </template>

                                        <v-date-picker
                                            v-model="reallyBefore"
                                            @input="srokMenu = false"
                                            color="teal"
                                            :min="min"
                                            :first-day-of-week="1"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("ФИО_руководителя_организации")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <div class="icon-click-row-group icrg-align-center">                                                    
                                        <div @click="onCheifSelect">
                                            <v-icon small v-tooltip.left-center="selectCheifTooltip">
                                                fas fa-edit
                                            </v-icon>
                                        </div>
                                        <div class="onlyReadData">
                                            <v-workplace-chip v-if="cheif"
                                                :id="cheif.id"
                                                :name="cheif.name"
                                                :canDelete="true"
                                                :delFunc="onDeleteCheif"
                                            />
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{$t("ФИО_специалистов")}}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <div class="icon-click-row-group icrg-align-center">                                                    
                                        <div @click="onSpecialsSelect">
                                            <v-icon small v-tooltip.left-center="selectSpecialsTooltip">
                                                fas fa-edit
                                            </v-icon>
                                        </div>
                                        <div class="onlyReadData more-per-lab-wrap">
                                            <template v-for="specialist in specialists">
                                                <v-workplace-chip 
                                                    :id="specialist.id"
                                                    :key="specialist.id"
                                                    :name="specialist.name"
                                                    :canDelete="true"
                                                    :delFunc="onDeleteSpecialist"
                                                />
                                            </template>
                                        </div>
                                    </div>
                                </v-col>
                            </v-row>

                        </v-form>

                    </v-card-text>
                </v-card>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn 
                    color="cyan"
                    text
                    depressed
                    @click="ok"
                    v-if="isValid"
                >
                    {{ $t("Сформировать_и_отправить") }} 
                </v-btn>

                <v-btn
                    color="blue-grey"
                    text
                    depressed
                    @click="cancel"
                >
                    {{ $t("Отмена") }}
                </v-btn>

            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import i18n from '@/i18n';
import sys from '@/services/system';

export default {
    name: "CSCPrepareConclusionDlg",
    data () {
        return {
            title: "Сформировать_заключение",
            srokMenu: false,
            
        }
    },
    computed: {
        ...mapGetters('global/actionsource', { getDataSource: 'getDataSource'}),
        ...mapGetters('qalaQyzmet/dialogs/cscPrepareConclusion', ['isVisible', 'isValid']),
        ...mapGetters({ requiredRule: 'getRequiredRule',}),

        conclusion: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscPrepareConclusion/getConclusion'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscPrepareConclusion/SET_CONCLUSION', v); 
                this.validateFormMethod();
            }
        },
        address: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscPrepareConclusion/getAddress'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscPrepareConclusion/SET_ADDRESS', v); 
                this.validateFormMethod();
            }
        },
        phone: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscPrepareConclusion/getPhone'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscPrepareConclusion/SET_PHONE', v); 
                this.validateFormMethod();
            }
        },
        recommendations: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscPrepareConclusion/getRecommendations'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscPrepareConclusion/SET_RECOMMENDATIONS', v); 
                this.validateFormMethod();
            }
        },
        reallyBefore: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscPrepareConclusion/getReallyBefore'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscPrepareConclusion/SET_REALLY_BEFORE', v); 
                this.validateFormMethod();
            }
        },
        cheif: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscPrepareConclusion/getCheif'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscPrepareConclusion/SET_CHEIF', v); 
                this.validateFormMethod();
            }
        },
        specialists: {
            get: function() {
                return this.$store.getters['qalaQyzmet/dialogs/cscPrepareConclusion/getSpecialists'];
            },
            set: function(v) {
                this.$store.commit('qalaQyzmet/dialogs/cscPrepareConclusion/SET_SPECIALISTS', v); 
                this.validateFormMethod();
            }
        },
        selectCheifTooltip(){
            return i18n.t("Выбрать_руководителя_организации");
        },
        selectSpecialsTooltip(){
            return i18n.t("Выбрать_специалистов");
        },
        min() {
            return this.$moment(new Date()).format('YYYY-MM-DD');
        }
    },
    filters: {
        formattedDate: function (value) {
            var formatedDate = sys.dateFormat(value, 'DD.MM.YYYY');
            return formatedDate ?? "";
        }
    },
    methods: {
        ...mapActions('qalaQyzmet/dialogs/cscPrepareConclusion', ['ok', 'cancel']),
        async onCheifSelect(){
            try {
                let select = await this.$store.dispatch('global/dialogs/selectMembersNew/open', {
                        title: i18n.t("Выбор_руководителя"),
                        includeInner: true,
                        multiple: false,
                        selected: this.cheif ? [this.cheif.id] : []
                    });
                this.cheif = {id: select.workplaceId, name: select.name};
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onDeleteCheif(){
            this.cheif = null;
        },
        async onSpecialsSelect(){
            try {
                let select = await this.$store.dispatch('global/dialogs/selectMembersNew/open', {
                    title: i18n.t("Выбор_специалистов"),
                    includeInner: true,
                    multiple: true,
                    selected: this.specialists ? this.specialists.map(s => s.id) : []
                });
                this.specialists = select.map(s => ({id: s.workplaceId, name: s.name}));
            }
            catch (ex) {
                console.log(ex);
            }
        },
        onDeleteSpecialist(id){
            let tmp = Array.from(this.specialists);
            let itemToRemove = tmp.find(x=>x.id == id);
            if (itemToRemove) {
                let index = tmp.indexOf(itemToRemove);
                if (index > -1) {
                    tmp.splice(index, 1);
                    this.specialists =  tmp;
                }
            }
        },
        validateFormMethod(){
            this.$refs?.form?.validate();    
        }
    }
}
</script>